// Get ver param from main.js so we can add it to all imported scripts for cache-busting
import 'regenerator-runtime/runtime';
import 'parsleyjs';
import '@electro-creative-workshop/electro-privacy';

import './components/primary-nav';
import MicroModal from 'micromodal';
import Social from './components/social-widget';
import GraphQL from './components/graphql';

let ver = document.currentScript.src.split('?')[1];
if (typeof ver === 'undefined') {
    // Fallback to looking for theme version in global variables
    ver = `ver=${Theme.version}`;
}
if (typeof ver === 'undefined') {
    // Fallback to making up a version from the clock, changes every 5 min
    ver = `ver=${Math.round(new Date().getTime() / (1000 * 300))}`;
}
ver = `?${ver}`;

window.social = new Social();
window.graphql = new GraphQL();

// Sentry
import * as Sentry from "@sentry/browser";
Sentry.init({
  dsn: Electro.Sentry.dsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: Electro.Sentry.environment,
  release: Electro.themeVersion,
  sampleRate: Electro.Sentry.sampleRate,
  maxBreadcrumbs: Electro.Sentry.maxBreadcrumbs,
  attachStacktrace: Electro.Sentry.attachStacktrace,
  tracesSampleRate: Electro.Sentry.tracesSampleRate,
  tracePropagationTargets: [WEBROOT],
  replaysSessionSampleRate: Electro.Sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: Electro.Sentry.replaysOnErrorSampleRate,
});
// Sentry END

// /////////////////////////////////////////////////////////////////////////////
// Modals
// /////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
    try {
        MicroModal.init({
            awaitCloseAnimation: true, // set to false, to remove close animation
            onShow: (modal) => {
                console.log('micromodal open', JSON.stringify(modal));
            },
            onClose: (modal) => {
                console.log('micromodal close', JSON.stringify(modal));
            },
        });
    } catch (e) {
        console.log('micromodal error: ', e);
    }
});
